export const projects = [
  {
    id: 1,
    demoUrl: "https://www.loom.com/embed/f7294c49890e492a86f51121d3ad4b85",
    githubUrl: "https://github.com/idanb93/Hackathon-2",
    websiteUrl: "",
    projectName: "Company Cloud-Visualizer",
    projectGif:
      "https://cdn.loom.com/sessions/thumbnails/f7294c49890e492a86f51121d3ad4b85-with-play.gif",
    description:
      "In this project, I built a full-stack application - Management System for IT Administrators that shows their company's cloud instances. I used Node.js, Express.js with a middleware, PostgreSQL on Heroku, and JWT to handle user sessions.",
    technologies: ["JavaScript", "Node.js", "Express.js", "PostgreSQL", "JWT"],
  },
  {
    id: 2,
    demoUrl: "https://www.loom.com/share/c00fb403c76b4798bedd150b37cecf47",
    githubUrl: "https://github.com/idanb93/Hackathon",
    websiteUrl: "",
    projectName: "Tech-Blog",
    projectGif:
      "https://cdn.loom.com/sessions/thumbnails/c00fb403c76b4798bedd150b37cecf47-with-play.gif",
    description:
      "In this project I built a client-side of a website (Tech-Blog) using HTML, CSS and JavaScript, I used local storage to save users' login information when switching between signup and login pages.",
    technologies: ["HTML", "CSS", "JavaScript", "DOM"],
  },
  {
    id: 3,
    demoUrl: "https://youtu.be/B_CfvlAqhYk",
    githubUrl: "https://github.com/idanb93/investments-portfolio",
    websiteUrl: "",
    projectName: "Investment-Portfolio",
    projectGif:
      "https://user-images.githubusercontent.com/35878173/104034881-22976680-51da-11eb-9055-85fc1b610809.gif",
    description:
      "In this project I built backend application - WebAPI that shows my investment portfolio, I used RESTful principles and built the project using SpringBoot framework.",
    technologies: ["Java", "Springboot", "REST", "API", "JSON"],
  },
  {
    id: 4,
    demoUrl: "https://www.youtube.com/watch?v=LkW4Uj31RZ0",
    githubUrl: "https://github.com/idanb93/devops-project",
    websiteUrl: "",
    projectName: "DevOps",
    projectGif:
      "https://user-images.githubusercontent.com/35878173/103166910-60d27480-482f-11eb-8b1e-73edccece4e5.gif",
    description:
      "CI/CD pipeline is built on 2 containers, The first container is Jenkins with a job that automatically retrieves files from a git repository when it detects new commits, The second container is a Tomcat server where the retrieved files from the git repository are being mapped to its webapps folder and automatically being displayed on the server.",
    technologies: ["Linux", "Bash", "Docker", "Git", "Jenkins", "Tomcat"],
  },
  {
    id: 4,
    demoUrl: "https://www.youtube.com/watch?v=LkW4Uj31RZ0",
    githubUrl: "https://github.com/idanb93/devops-project",
    websiteUrl: "",
    projectName: "DevOps",
    projectGif:
      "https://user-images.githubusercontent.com/35878173/103166910-60d27480-482f-11eb-8b1e-73edccece4e5.gif",
    description:
      "CI/CD pipeline is built on 2 containers, The first container is Jenkins with a job that automatically retrieves files from a git repository when it detects new commits, The second container is a Tomcat server where the retrieved files from the git repository are being mapped to its webapps folder and automatically being displayed on the server.",
    technologies: ["Linux", "Bash", "Docker", "Git", "Jenkins", "Tomcat"],
  },
  {
    id: 4,
    demoUrl: "https://www.youtube.com/watch?v=LkW4Uj31RZ0",
    githubUrl: "https://github.com/idanb93/devops-project",
    websiteUrl: "",
    projectName: "DevOps",
    projectGif:
      "https://user-images.githubusercontent.com/35878173/103166910-60d27480-482f-11eb-8b1e-73edccece4e5.gif",
    description:
      "CI/CD pipeline is built on 2 containers, The first container is Jenkins with a job that automatically retrieves files from a git repository when it detects new commits, The second container is a Tomcat server where the retrieved files from the git repository are being mapped to its webapps folder and automatically being displayed on the server.",
    technologies: ["Linux", "Bash", "Docker", "Git", "Jenkins", "Tomcat"],
  },
]
